import React, { useState } from 'react';
import { AppBar, Toolbar, Button, Menu, MenuItem, Box, Container, IconButton, Drawer, List, ListItem, Collapse } from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from "react-router-dom";

import logo from '../../assets/images/logo.png';

const Header = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const toggleSubmenu = () => setSubmenuOpen(!submenuOpen);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleNavigation = (e, to, hash = null) => {
    e.preventDefault();
    navigate(to, { replace: true });

    setTimeout(() => {
      if (hash) {
        const section = document.querySelector(hash);
        if (section) section.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 500);
  };

  return (
    <AppBar className='main-menu' position="sticky" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
      <Container maxWidth="lg">
        <Toolbar>
          {/* Logo */}
          <Box sx={{ flexGrow: 1, alignItems: 'center' }}>
            <Link
              onClick={(e) => handleNavigation(e, "/", null)}
              style={{ display: "inline-block", textDecoration: "none" }}
              aria-label="Inicio"
            >
              <img src={logo} alt="Logo E2E Travel Solutions" style={{ height: '40px' }} />
            </Link>
          </Box>

          {/* Menú Desktop */}
          {!isMobile && (
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button onClick={(e) => handleNavigation(e, "/", null)} sx={{ color: 'primary.main', textTransform: 'none', px: 2 }}>
                Inicio
              </Button>
              <Button onClick={(e) => handleNavigation(e, "/nosotros", null)} sx={{ color: 'primary.main', textTransform: 'none', px: 2 }}>
                Nosotros
              </Button>
              <Button
                sx={{ color: 'primary.main', textTransform: 'none', px: 2 }}
                aria-controls="solutions-menu"
                aria-haspopup="true"
                onClick={(e) => handleNavigation(e, "/solutions", null)}
                onMouseEnter={handleMenuOpen}
                endIcon={isMenuOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              >
                Soluciones
              </Button>
              <Button onClick={(e) => handleNavigation(e, "/", "#partners")} sx={{ color: 'primary.main', textTransform: 'none', px: 2 }}>
                Alianzas
              </Button>
              <Button 
                component="a"
                href="https://demo.e2etravelsolutions.com/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'primary.main', textTransform: 'none', px: 2 }}>
                Demo
              </Button>
              <Button onClick={(e) => handleNavigation(e, "/docs", null)} sx={{ color: 'primary.main', textTransform: 'none', px: 2 }}>
                Docs
              </Button>
              {/* <Button onClick={(e) => handleNavigation(e, "/blog", null)} sx={{ color: 'primary.main', textTransform: 'none', px: 2 }}>
                Blog
              </Button> */}
              <Button onClick={(e) => handleNavigation(e, "/contact", null)} color="primary" variant="contained" sx={{ py: 0.5, px: 2 }}>
                Contáctanos
              </Button>
            </Box>
          )}

          {/* Menú Mobile */}
          {isMobile && (
            <>
              <IconButton onClick={toggleDrawer}>
                {drawerOpen ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
              <Drawer anchor="top" open={drawerOpen} onClose={toggleDrawer}>
                <List sx={{ width: '100%' }}>
                  <ListItem button onClick={(e) => handleNavigation(e, "/", null)}>
                    Inicio
                  </ListItem>
                  <ListItem button onClick={(e) => handleNavigation(e, "/nosotros", null)}>
                    Nosotros
                  </ListItem>
                  <ListItem button onClick={toggleSubmenu}>
                    Soluciones {submenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={submenuOpen} timeout="auto" unmountOnExit>
                    <List disablePadding>
                      <ListItem button sx={{ pl: 4 }} onClick={(e) => handleNavigation(e, "/solutions/air", null)}>
                        End to end Aéreos
                      </ListItem>
                      <ListItem button sx={{ pl: 4 }} onClick={(e) => handleNavigation(e, "/solutions/hotels", null)}>
                        End to end Hoteles
                      </ListItem>
                      <ListItem button sx={{ pl: 4 }} onClick={(e) => handleNavigation(e, "/solutions/assist", null)}>
                        End to end Asistencia al viajero
                      </ListItem>
                      <ListItem button sx={{ pl: 4 }} onClick={(e) => handleNavigation(e, "/solutions/trains", null)}>
                        End to end Trenes
                      </ListItem>
                      <ListItem button sx={{ pl: 4 }} onClick={(e) => handleNavigation(e, "/solutions/tour-circuits", null)}>
                        End to end Circuitos
                      </ListItem>
                      <ListItem button sx={{ pl: 4 }} onClick={(e) => handleNavigation(e, "/solutions/automation", null)}>
                        Servicios de Automatización Robótica de Procesos Clave
                      </ListItem>
                      <ListItem button sx={{ pl: 4 }} onClick={(e) => handleNavigation(e, "/solutions/discovery", null)}>
                        Servicio de Discovery Tecnológico
                      </ListItem>
                    </List>
                  </Collapse>
                  <ListItem button onClick={(e) => handleNavigation(e, "/", "#partners")}>
                    Alianzas
                  </ListItem>
                  {/* <ListItem button onClick={(e) => handleNavigation(e, "/blog", null)}>
                    Blog
                  </ListItem> */}
                  <ListItem button onClick={(e) => handleNavigation(e, "/contact", null)}>
                    Contáctanos
                  </ListItem>
                </List>
              </Drawer>
            </>
          )}

          {/* Submenú Desktop */}
          <Menu
            id="solutions-menu"
            anchorEl={anchorEl}
            open={isMenuOpen}
            onClose={handleMenuClose}
            MenuListProps={{ onMouseLeave: handleMenuClose }}
            slotProps={{
              paper: {
                sx: {
                  border: '1px solid #ddd',
                  boxShadow: 'none',
                  mt: 1,
                  '& .MuiMenuItem-root': {
                    color: 'primary.main',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  },
                },
              },
            }}
          >
            <MenuItem onClick={(e) => handleNavigation(e, "/solutions/air", null)}>End to end Aéreos</MenuItem>
            <MenuItem onClick={(e) => handleNavigation(e, "/solutions/hotels", null)}>End to end Hoteles</MenuItem>
            <MenuItem onClick={(e) => handleNavigation(e, "/solutions/assist", null)}>End to end Asistencia al viajero</MenuItem>
            <MenuItem onClick={(e) => handleNavigation(e, "/solutions/trains", null)}>End to end Trenes</MenuItem>
            <MenuItem onClick={(e) => handleNavigation(e, "/solutions/tour-circuits", null)}>End to end Circuitos</MenuItem>
            <MenuItem onClick={(e) => handleNavigation(e, "/solutions/automation", null)}>Servicios de Automatización de Procesos Clave</MenuItem>
            <MenuItem onClick={(e) => handleNavigation(e, "/solutions/discovery", null)}>Servicio de Discovery Tecnológico</MenuItem>
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
